var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: { visible: _vm.isVisible, "destroy-on-close": true, width: "70%" },
      on: { close: _vm.hide },
    },
    [
      _c("template", { slot: "title" }, [
        _c("span", { staticClass: "text-uppercase" }, [
          _vm._v("\n      Security groups: "),
          _c("span", { staticClass: "font-weight-bold" }, [
            _vm._v(_vm._s(_vm.name)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("index-component", { attrs: { "index-url": _vm.url } }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }